import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ScheduledTask\StoreScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/StoreScheduledTaskController.php
* @route '/api/scheduled-task'
*/
const StoreScheduledTaskController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreScheduledTaskController.url(options),
    method: 'post',
})

StoreScheduledTaskController.definition = {
    methods: ["post"],
    url: '/api/scheduled-task',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ScheduledTask\StoreScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/StoreScheduledTaskController.php
* @route '/api/scheduled-task'
*/
StoreScheduledTaskController.url = (options?: RouteQueryOptions) => {
    return StoreScheduledTaskController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ScheduledTask\StoreScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/StoreScheduledTaskController.php
* @route '/api/scheduled-task'
*/
StoreScheduledTaskController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreScheduledTaskController.url(options),
    method: 'post',
})

export default StoreScheduledTaskController